/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import { Link, ResponsiveImage } from "@quintype/components";
import PropType from "prop-types";
import React from "react";
import { getStoryMetadata } from "../../../utils";
import NlSenaWrapper from "../../pages/nl-sena-wrapper";

import "./three-sena-collection.m.css";

const StoryColumnCard = ({ collection, isFirstItem }) => {
  const stories = collection.items
    .filter(item => item.type === "story")
    .slice(0, 6);

  return (
    <div styleName="story-column-wrapper">
      <div styleName="title-wrapper">
        <h3 styleName="title">{collection.name}</h3>
        <p styleName="border-bottom"></p>
      </div>
      <div styleName={`content-wrapper ${isFirstItem ? "dark-container" : ""}`}>
        {stories.map((story, i) => (
          <>
            <div styleName="story-card" key={story.id}>
              {i === 0 && (
                <Link href={`/${story.story.slug}`}>
                  <ResponsiveImage
                    slug={story.story["hero-image-s3-key"]}
                    metadata={getStoryMetadata(story)}
                    aspectRatio={[16, 9]}
                    defaultWidth={480}
                    widths={[250, 480, 640]}
                    sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
                    imgParams={{ auto: ["format", "compress"] }}
                    className="responsive-img"
                    styleName="image"
                  />
                </Link>
              )}
              <Link href={`/${story.story.slug}`}>
                <p
                  styleName={`story-headline ${
                    isFirstItem ? "dark-story-headline" : ""
                  }`}
                >
                  {story.story.headline}
                </p>
              </Link>
              {i === 0 && (
                <div
                  styleName={`date-author-wrapper ${
                    isFirstItem ? "dark-date-author-wrapper" : ""
                  }`}
                >
                  <Link href={`/author/${story.story.authors[0].slug}`}>
                    <p styleName="author-name">{story.story.authors[0].name}</p>
                  </Link>
                  <time styleName="published-at">
                    {new Date(story.story["published-at"]).toDateString()}
                  </time>
                </div>
              )}
            </div>
            {i === stories.length - 1 && <div styleName="pt-8"></div>}
            {i !== stories.length - 1 && <div styleName="bottom-rule"></div>}
          </>
        ))}
      </div>
    </div>
  );
};

const ThreeSenaCollectionHybrid = ({ associatedMetadata, collection }) => {
  const {
    first_campaign_id,
    second_campaign_id,
    third_campaign_id
  } = associatedMetadata;

  const collections = collection.items;

  let num = 0;
  let derivedComponentClassName = "";
  let derivedSenaClassName = "";

  if (first_campaign_id) num++;
  if (second_campaign_id) num++;
  if (third_campaign_id) num++;

  derivedComponentClassName = `flex${3 - num}`;
  derivedSenaClassName = `flex${num}`;

  return (
    <div styleName="collection-wrapper">
      <div styleName={`component-wrapper ${derivedComponentClassName}`}>
        {collections.map((item, i) => (
          <StoryColumnCard
            key={item.id}
            collection={item}
            isFirstItem={i === 0}
          />
        ))}
        {/* <div styleName="img-wrapper">
          <Link href={`/download-app?ref=vertical-offer`}>
            <img
              styleName="banner"
              src="https://images.assettype.com/newslaundry/2022-05/b80947fb-36c4-434d-afac-a5d6bfc63b72/vertical_banner_new.jpg"
            />
          </Link>
        </div> */}
      </div>
      <div styleName={`sena-component-wrapper ${derivedSenaClassName}`}>
        {first_campaign_id && (
          <div styleName="sena-wrapper">
            <div styleName="title-wrapper">
              <h3 styleName="title">एनएल-टीएनएम इलेक्शन फंड</h3>
              <p styleName="border-bottom"></p>
            </div>
            <NlSenaWrapper
              showSingleCampaign={true}
              campaignId={first_campaign_id}
            />
          </div>
        )}
        {second_campaign_id && (
          <div styleName="sena-wrapper">
            <div styleName="title-wrapper">
              <h3 styleName="title">Sena</h3>
              <p styleName="border-bottom"></p>
            </div>
            <NlSenaWrapper
              showSingleCampaign={true}
              campaignId={second_campaign_id}
            />
          </div>
        )}
        {third_campaign_id && (
          <div styleName="sena-wrapper">
            <div styleName="title-wrapper">
              <h3 styleName="title">Sena</h3>
              <p styleName="border-bottom"></p>
            </div>
            <NlSenaWrapper
              showSingleCampaign={true}
              campaignId={third_campaign_id}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { ThreeSenaCollectionHybrid };

ThreeSenaCollectionHybrid.propType = {
  associatedMetadata: PropType.object,
  collection: PropType.object
};
